import { QueryObserverOptions } from '@tanstack/react-query'

import config from '../../config'
import { buildGetQuery } from '../../util'

import { ISafetyCaseHazard, IGetRequestObject } from '../../interfaces'

type Params = {
  id: number
}

const getSafetyCaseHazardByIdQueryRequest = (params: Params): IGetRequestObject => {
  const { id } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/Hazards/${id}`,
  }
}

const useSafetyCaseHazardByIdQueryBase = buildGetQuery<Params, undefined, ISafetyCaseHazard | undefined>({
  getRequest: getSafetyCaseHazardByIdQueryRequest,
  getQueryKey: params => ['safety-case-hazard-by-id', params.id],
  defaultOptions: { initialData: undefined },
})

const useSafetyCaseHazardByIdQuery = (
  params: Params,
  options?: QueryObserverOptions<ISafetyCaseHazard | undefined, Error>,
) => useSafetyCaseHazardByIdQueryBase(params, undefined, options)

export default useSafetyCaseHazardByIdQuery
